import React from 'react';
import { cn } from '../../lib/classNames';

const LEVEL_CLASS = {
  1: 'vc-heading vc-heading--1',
  2: 'vc-heading vc-heading--2',
  3: 'vc-heading vc-heading--3',
};

/**
 * Scala tipografica unica (10_RESTYLING_SITO_PUBBLICO.md §3.2).
 * level 1 = 44/32, 2 = 30/24, 3 = 20/18.
 */
export function Heading({ level = 2, as, children, className = '', ...rest }) {
  const lv = Math.min(3, Math.max(1, Number(level) || 2));
  const Tag = as || `h${lv}`;
  return (
    <Tag className={cn(LEVEL_CLASS[lv], className)} {...rest}>
      {children}
    </Tag>
  );
}

export default Heading;
